import script from "./NewProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./NewProducts.vue?vue&type=script&setup=true&lang=js"

import "./NewProducts.vue?vue&type=style&index=0&id=190c1d5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-190c1d5e"]])

export default __exports__